<div class="card">
  <div class="card-header">
    <h4>Settlement Report</h4>
  </div>
  <div class="card-body m-0">
    <div class="row mb-4">
      <div class="col-xl-6">

        <button type="button" class="btn bg-danger-custom" (click)="isQuickFilter=!isQuickFilter">
          Filters <i class="feather icon-filter"></i>
        </button>
        <button type="button" class="btn bg-danger-custom" *ngIf="permissions.includes('Search')" (click)="exportAsExcelFile()">
          Export <i class="feather icon-download"></i>
        </button>
        <button type="button" class="btn bg-danger-custom" *ngIf="permissions.includes('Search')" (click)="onBackgroundExport()">Export All<i class="feather icon-download-cloud"></i></button>

      </div>
      <div class="col-xl-3">
        <ng-select [(ngModel)]="selectedAccount" placeholder="Select Bank Acc" (change)="checkAccount($event)">
          <ng-option *ngFor="let account of accountData" [value]="account.accountNumber">
            {{account.accountName}} ({{account.accountNumber}})
          </ng-option>
        </ng-select>
      </div>
      
      <div class="col-xl-3">
        <i (click)="toggleBalanceVisibility()" [ngClass]="isBalanceVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        <span *ngIf="isBalanceVisible">AED.{{balanceAmount}}</span>
        <span *ngIf="!isBalanceVisible">AED.XXXX</span>
      
        <!-- Button to toggle balance visibility -->
        <button class="btn bg-danger btn-sm" type="button" (click)="checkBalance()">Check Balance</button>
      </div>
      
    </div>
    <div *ngIf="isQuickFilter" class="row" style="min-height: 100px">
      <div class="card">
        <div class="card-body">
          <form [formGroup]="settlementForm">
            <div class="row">
              <div class="col-md-4">
                <label class="col-form-label" for="merchant">Select Merchant</label>
                <!-- <ng-select id="merchant" placeholder="Select Merchant" [inputAttrs]="{maxlength: '100'}"
                  formControlName="merchant">
                  <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.userId">
                    {{merchant.fullName}} ({{merchant.userId}})
                  </ng-option>
                </ng-select> -->
                <input class="form-control" id="merchant" formControlName="merchant" type="text"
                  placeholder="Enter Merchant ID">
              </div>

              <div class="col-md-4">
                <label class="col-form-label" for="processedBy">Select Approver</label>
                <input class="form-control" id="processedBy" formControlName="processedBy" type="text"
                  placeholder="Select Approver">
              </div>

              <div class="col-md-4">
                <label class="col-form-label" for="accountNumber">Select CMA Bank</label>
                <ng-select id="accountNumber" formControlName="accountNumber" placeholder="Select CMA Bank">
                  <!-- <ng-option *ngFor="let account of accountData" [value]="account.accountNumber">
                          {{account.accountName}} ({{account.accountNumber}})
                        </ng-option> -->
                  <ng-option value="ENBD">ENBD</ng-option>

                </ng-select>
              </div>

              <div class="col-md-4">
                <label class="col-form-label" for="status">Status</label>
                <ng-select id="txnStatus" placeholder="Select Transaction" formControlName="status"
                  [closeOnSelect]="false">
                  <ng-option value="INITIATED">Initiated</ng-option>
                  <ng-option value="SUCCESS">Success</ng-option>
                  <ng-option value="FAILED">Failed</ng-option>
                  <ng-option value="PENDING">Pending</ng-option>
                  <ng-option value="REJECTED">Rejected</ng-option>
                </ng-select>
              </div>

              <div class="col-md-4">
                <label class="col-form-label" for="searchFromDate">Select Requested Date</label>
                <input #filSearchFromDate [(ngModel)]="searchFromDate" ngbDatepicker #d="ngbDatepicker"
                  class="form-control" id="searchFromDate" placeholder="yyyy-mm-dd" [maxDate]="maxDateFrom"
                  (click)="d.toggle()" (ngModelChange)="changeDate()" [ngModelOptions]="{standalone: true}" />
              </div>

              <div class="col-md-4">
                <label class="col-form-label" for="searchToDate">Select Settled Date</label>
                <input #filSearchToDate [(ngModel)]="searchToDate" ngbDatepicker #d1="ngbDatepicker"
                  class="form-control" id="searchToDate" placeholder="yyyy-mm-dd" [maxDate]="maxDate"
                  [minDate]="minDate" (click)="d1.toggle()" (ngModelChange)="changeEndDate()"
                  [ngModelOptions]="{standalone: true}" />
              </div>
            </div>

            <div class="row mt-2 justify-content-end text-right">
              <div class="mb-3 col-md-6">
                <button class="btn bg-danger-custom" type="button" (click)="getSettlementReport()">
                  <i class="feather icon-search"></i> Search
                </button>
                <button (click)="resetFilter()" class="btn bg-danger-custom" type="button">Reset</button>

              </div>
            </div>
          </form>
        </div>
      </div>
    </div>


    <div class="row mb-0" style="min-height: 380px">
      <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
        <ag-grid-angular [enableCellTextSelection]=true (sortChanged)="onSortChange($event)"
          (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)"
          (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
          (rowDoubleClicked)="onRowDoubleClicked($event)" (search)="globalSearch" [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef" [tooltipShowDelay]="0" [enableCellTextSelection]=true [rowData]="rowData"
          [rowModelType]="" [rowSelection]="'single'" style="width: 100%; height: auto;">
        </ag-grid-angular>
      </div>
    </div>

    <div class="row mt-2" *ngIf="rowData.length">
      <div class="col-4 col-xs-4 d-flex">
        <select [(ngModel)]="pageRecords" (ngModelChange)="onPageSizeChanges($event)"
          class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
          <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
        </select>
        <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
      </div>

      <div class="col-8 col-xs-8">
        <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="pageNumber" [boundaryLinks]="true"
          [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageRecords" [rotate]="false" [ellipses]="false"
          class="d-flex justify-content-end col-8 align-right" [directionLinks]="true">
        </ngb-pagination>
      </div>
    </div>

  </div>

  <ng-template #settlementModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Settlement Details</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <h5 class="modal-title" id="modal-basic-title">Internal Transaction Logs</h5>
      <div class="row mb-0" style="min-height: 380px;">
        <!-- First AG Grid for Internal Transaction Logs -->
        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
          <ag-grid-angular [enableCellTextSelection]="true" [columnDefs]="internalTransactionColumnDefs"
            [defaultColDef]="defaultColDef" [tooltipShowDelay]="0" [enableCellTextSelection]="true"
            [rowData]="internalTransactionRowData" [rowModelType]="'clientSide'" [rowSelection]="'single'"
            style="width: 100%; height: auto;">
          </ag-grid-angular>
        </div>
      </div>
      <h5 class="modal-title mt-4" id="modal-basic-title">Logs</h5>

      <!-- Second AG Grid for Logs -->
      <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px;min-height: 380px;">

        <ag-grid-angular [enableCellTextSelection]="true" [columnDefs]="logsColumnDefs" [defaultColDef]="defaultColDef"
          [tooltipShowDelay]="0" [enableCellTextSelection]="true" [rowData]="logsRowData" [rowModelType]="'clientSide'"
          [rowSelection]="'single'" style="width: 100%; height: auto;">
        </ag-grid-angular>
      </div>

    </div>
    <div class="modal-footer justify-content-center">
      <button type="button" class="btn btn-danger" (click)="modal.close('Cancel')">Close</button>
    </div>
  </ng-template>

  <!-- <ng-template #confirmModal let-modal> -->
  <!-- Approve Modal Template -->
  <ng-template #confirmModal let-modal>
    <form #remarkForm="ngForm" (ngSubmit)="approveAction(remark)">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Are you Sure?</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
      </div>
      <div class="modal-body">
        <div class="mt-3">
          <p><strong>Note:</strong> Please note PAY10 Will incur a cost on this transaction, hence, make sure to review
            the settlement request raised by the merchant before approving it.</p>
          <p><strong>Note:</strong> Please note this action will DEBIT the specific CMA Account Configured for the
            merchant.</p>
        </div>
        <div class="form-group">
          <!-- Add required validation and bind to ngModel -->
          <textarea class="form-control" rows="3" [(ngModel)]="remark" name="remark" #remarkInput="ngModel"
            placeholder="Enter your remark here..." required></textarea>
          <!-- Validation feedback -->
          <div *ngIf="remarkInput.invalid && remarkInput.touched" class="text-danger">
            Remark is required.
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-center">
        <!-- Disable the Approve button if the form is invalid -->
        <button type="button" class="btn btn-success" (click)="approveAction(remark)"
          [disabled]="remarkInput.invalid">Approve</button>
        <button type="button" class="btn btn-danger" (click)="modal.close('Cancel')">Cancel</button>
      </div>
    </form>
  </ng-template>

  <!-- Reject Modal Template -->
  <ng-template #confirmModalReject let-modal>
    <form #remarkForm="ngForm" (ngSubmit)="rejectAction(remark)">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Are you Sure?</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
      </div>
      <div class="modal-body">
        <div class="mt-3">
          <p><strong>Note:</strong> Make sure to review the settlement request raised by the merchant before rejecting
            it.</p>
          <p><strong>Note:</strong> Please note this action will notify the merchant that PAY10 has rejected their
            request upon reviewal.</p>
        </div>
        <div class="form-group">
          <!-- Add required validation and bind to ngModel -->
          <textarea class="form-control" rows="3" [(ngModel)]="remark" name="remark" #remarkInput="ngModel"
            placeholder="Enter your remark here..." required></textarea>
          <!-- Validation feedback -->
          <div *ngIf="remarkInput.invalid && remarkInput.touched" class="text-danger">
            Remark is required.
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-center">
        <!-- Disable the Reject button if the form is invalid -->
        <button type="button" class="btn btn-success" (click)="rejectAction(remark)"
          [disabled]="remarkInput.invalid">Reject</button>
        <button type="button" class="btn btn-danger" (click)="modal.close('Cancel')">Cancel</button>
      </div>
    </form>
  </ng-template>

  <ng-template #retryModal let-modal>
    <form #remarkForm="ngForm" (ngSubmit)="retryAction(remark)">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Are you Sure?</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
      </div>
      <div class="modal-body">
        <div class="mt-3">
          <p><strong>Note:</strong> Make sure to review the settlement request raised by the merchant before rejecting
            it.</p>
          <p><strong>Note:</strong> Please note this action will notify the merchant that PAY10 has rejected their
            request upon reviewal.</p>
        </div>
        <div class="form-group">
          <!-- Add required validation and bind to ngModel -->
          <textarea class="form-control" rows="3" [(ngModel)]="remark" name="remark" #remarkInput="ngModel"
            placeholder="Enter your remark here..." required></textarea>
          <!-- Validation feedback -->
          <div *ngIf="remarkInput.invalid && remarkInput.touched" class="text-danger">
            Remark is required.
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-center">
        <!-- Disable the Reject button if the form is invalid -->
        <button type="button" class="btn btn-success" (click)="retryAction(remark)"
          [disabled]="remarkInput.invalid">Approve</button>
        <button type="button" class="btn btn-danger" (click)="modal.close('Cancel')">Cancel</button>
      </div>
    </form>
  </ng-template>

</div>